import axios from 'axios';
import * as yup from 'yup';
import { timelineActivitySchema } from '~/schemas/timelineActivitySchema';
import { useQuery } from 'react-query';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup
        .array()
        .defined()
        .of(timelineActivitySchema),
});
async function getPatientTimeline({ patientId }) {
    const response = await axios.post('/api/patientTimeline/getPatientTimeline', {
        patient_id: patientId,
    });
    const { data } = await responseSchema.validate(response.data);
    return {
        // @ts-ignore
        timelineActivities: data,
    };
}
export const useGetPatientTimeline = ({ patientId }) => {
    return useQuery(['getPatientTimeline', patientId], () => getPatientTimeline({ patientId }), {
        staleTime: 1200000,
        refetchOnWindowFocus: true, // Refetch when user returns to tab
    });
};
